import React from "react"
import { Button, Input, Card, Divider, Icon, Table } from "semantic-ui-react"
import html2pdf from "html2pdf.js"
import { sendFnoFormApi } from "../config/apiUrls"
import { apiPost } from "../utils/apiConnector"
import { form200 } from "./Report200"
import { form910 } from "./Report910"
import FormESF from "./FormESF"

const date = new Date()
const year = date.getFullYear()
const pervoePolugodie = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь"]
const vtoroyePolugodie = [
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
]

export default class ReportHolder extends React.Component {
  state = {
    pervoePolugodie: true,
    vtoroyePolugodie: false,
    ip: true, // data
    too: false, // data
    sh: false, // data
    pensioner: false, // data
    prevYear: false,
    thisYear: true,
    year: year, // data
    workers: [],
    form910: {
      F000: ["", "", "", "", "", "", ""],
      F001: ["", "", "", ""],
      F002: "",
      F003: ["", "", ""],
      F004: "",
      F005: "",
      F006: "",
      F007: "",
      F008: "",
      F009: "",
      F010: "",
      F011: "",
      F012: ["", "", "", "", "", "", ""],
      F013: ["", "", "", "", "", "", ""],
      F014: ["", "", "", "", "", "", ""],
      F015: ["", "", "", "", "", "", ""],
      F016: ["", "", "", "", "", "", ""],
      F017: ["", "", "", "", "", "", ""],
      F018: ["", "", "", "", "", "", ""],
      F019: ["", "", "", "", "", "", ""],
      F020: ["", "", "", "", "", "", ""],
      F021: ["", "", "", "", "", "", ""],
      F022: ["", "", "", "", "", "", ""],
      F023: ["", "", "", "", "", "", ""],
      F024: ["", "", "", "", "", "", ""],
      F025: ["", "", "", "", "", "", ""],
      F026: ["", "", "", "", "", "", ""],
      F027: ["", "", "", ""],
      F028: [""],
      F001b: false,
      F001d: false,
      F006b: false,
      F005b: false,
    },
    form200: {
      F000: ["", "", "", ""],
      F001: ["", "", "", ""],
      F002: ["", "", "", ""],
      F003: ["", "", "", ""],
      F004: ["", "", "", ""],
      F005: ["", "", "", ""],
      F006: ["", "", "", ""],
      F007: ["", "", "", ""],
      F008: ["", "", "", ""],
      F009: ["", "", "", ""],
      F010: ["", "", "", ""],
      F011: ["", "", "", ""],
      F01001: ["", "", "", "", "", ""],
      F01002: ["", "", "", ""],
      F01003: "",
      F01004: "",
      F01005: "",
      F01006: ["", "", "", ""],
      F01007: ["", "", "", ""],
      F01008: ["", "", "", ""],
      F01009: ["", "", "", ""],
      F01010: ["", "", ""],
      F01011: ["", "", ""],
      F01012: ["", "", ""],
      F01013: ["", "", "", ""],
      F01014: ["", "", "", ""],
      F01015: ["", "", "", ""],
      F01016: ["", "", "", ""],
      F01017: ["", "", "", ""],
    },
  }

  addWorker = () => {
    const workers = [...this.state.workers]
    workers.push(
      <>
        <div style={{ marginTop: 10 }}>
          <Table compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  {this.state.workers.length + 1}. <Input value={"Работник"} />
                </Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell>Месяц</Table.HeaderCell>
                <Table.HeaderCell>Зарплата</Table.HeaderCell>
                <Table.HeaderCell>Вычет МЗП</Table.HeaderCell>
                <Table.HeaderCell>Пенсионер</Table.HeaderCell>
                <Table.HeaderCell>Инвалид</Table.HeaderCell>
                <Table.HeaderCell>Вред. Производство</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>1 мес.</Table.Cell>
                <Table.Cell>
                  <Input type="number" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>2 мес.</Table.Cell>
                <Table.Cell>
                  <Input type="number" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>3 мес.</Table.Cell>
                <Table.Cell>
                  <Input type="number" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
                <Table.Cell>
                  <Input type="checkbox" />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </>,
    )
    this.setState({ workers: workers })
  }

  formulaeDecomposer = (q) => {
    // () + - * /
    console.log(q)
    const y = q.split("=")
    let left = y[0]
    let right = y[1]
    const stack = []
    const symbols = []
    let num = ""
    for (let i = 0; i < right.length; i++) {
      let w = right.charAt(i)
      if (w === "(") {
        if (num === "") {
          stack.push(num)
        }
        num = ""
        symbols.push(w)
      } else if (w === ")") {
        if (num === "") {
          stack.push(num)
        }
        num = ""
        let l = symbols.pop()
        if (l === "(") {
          continue
        }
        while (l !== "(") {
          stack.push(l)
          l = symbols.pop()
        }
      } else if (w === "+" || w === "-") {
        if (num === "") {
          stack.push(num)
        }
        num = ""
        let l = symbols.pop()
        if (l === "+" || l === "-" || l === "*" || l === "/") {
          stack.push(l)
        } else {
          symbols.push(l)
        }
      } else if (w === "*" || w === "/") {
        symbols.push(w)
      } else {
        num += w
      }
    }
    if (symbols.length > 0) {
      for (let i = 0; i < symbols.length; i++) {
        stack.push(symbols[i])
      }
    }
    console.log(stack)
    console.log(symbols)
    return true
  }

  addHeader = (num, text) => {
    let field = <></>
    field = (
      <>
        <div>
          <div style={{ textAlign: "center" }}>
            <h4>Форма {num}</h4>
          </div>
          <div style={{ textAlign: "center" }}>
            <h4>{text}</h4>
          </div>
        </div>
      </>
    )
    return field
  }

  addTitle = (text) => {
    let field = <></>
    field = (
      <>
        <div style={{ textAlign: "center" }}>
          <h4>{text}</h4>
        </div>
      </>
    )
    return field
  }

  ftype0 = (num, text, formnum, fieldnum, formulae, index, onСhange) => {
    let field = (
      <>
        {" "}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <Input disabled value={num} />
            <span style={{ display: "inline-block", width: 10 }}></span>
            {text}
          </div>
          <div>
            <Input
              type="number"
              value={this.state[formnum][fieldnum]}
              onChange={
                formulae
                  ? (e, d) => {
                      if (formulae === "self") {
                        const form = this.state[formnum]
                        form[fieldnum] = d.value
                        const newState = {}
                        newState[formnum] = form
                        this.setState(newState)
                      } else {
                        if (onСhange) {
                          onСhange(e, d)
                        } else {
                          const form = this.state[formnum]
                          if (index) {
                            form[fieldnum][index] = d.value
                          } else {
                            form[fieldnum] = d.value
                          }
                          const newState = {}
                          newState[formnum] = form
                          this.setState(newState)
                          formulae.map((formula) => {
                            this.formulaeDecomposer(formula)
                          })
                        }
                      }
                    }
                  : onСhange
                  ? (e, d) => {
                      onСhange(e, d)
                    }
                  : () => {}
              }
            />
          </div>
        </div>
      </>
    )
    return field
  }

  ftype1 = (text, formnum, fieldnum, num) => {
    let field = (
      <>
        <div>
          <div>
            <Input disabled value={num} />
            <span style={{ display: "inline-block", width: 10 }}></span>
            {text}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: 10,
            }}
          >
            <div>
              <div>
                1 мес. I
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][0]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[0] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0
                    y[3] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}>
                2 мес. II
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][1]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[1] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0
                    y[3] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
            </div>
            <div>
              <div>
                3 мес. III
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][2]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[2] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0
                    y[3] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}>
                Итого за отчетный квартал IV
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][3]}
                  onChange={() => {
                    this.setState()
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
    return field
  }

  ftype2 = (num, text, formnum, fieldnum) => {
    let field = (
      <>
        <div>
          <div>
            <Input disabled value={num} />
            <span style={{ display: "inline-block", width: 10 }}></span>
            {text}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: 10,
            }}
          >
            <div>
              <div>
                1 мес. I
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][0]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[0] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0 + parseInt(y[3])
                      ? parseInt(y[3])
                      : 0 + parseInt(y[4])
                      ? parseInt(y[4])
                      : 0 + parseInt(y[5])
                      ? parseInt(y[5])
                      : 0
                    y[6] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}>
                2 мес. II
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][1]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[1] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0 + parseInt(y[3])
                      ? parseInt(y[3])
                      : 0 + parseInt(y[4])
                      ? parseInt(y[4])
                      : 0 + parseInt(y[5])
                      ? parseInt(y[5])
                      : 0
                    y[6] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}>
                3 мес. III
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][2]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[2] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0 + parseInt(y[3])
                      ? parseInt(y[3])
                      : 0 + parseInt(y[4])
                      ? parseInt(y[4])
                      : 0 + parseInt(y[5])
                      ? parseInt(y[5])
                      : 0
                    y[6] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
            </div>
            <div>
              <div>
                4 мес. IV
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][3]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[3] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0 + parseInt(y[3])
                      ? parseInt(y[3])
                      : 0 + parseInt(y[4])
                      ? parseInt(y[4])
                      : 0 + parseInt(y[5])
                      ? parseInt(y[5])
                      : 0
                    y[6] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}>
                5 мес. V
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][4]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[4] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0 + parseInt(y[3])
                      ? parseInt(y[3])
                      : 0 + parseInt(y[4])
                      ? parseInt(y[4])
                      : 0 + parseInt(y[5])
                      ? parseInt(y[5])
                      : 0
                    y[6] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}>
                6 мес. VI
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][5]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[5] = d.value
                    let sum = 0
                    sum = parseInt(y[0])
                      ? parseInt(y[0])
                      : 0 + parseInt(y[1])
                      ? parseInt(y[1])
                      : 0 + parseInt(y[2])
                      ? parseInt(y[2])
                      : 0 + parseInt(y[3])
                      ? parseInt(y[3])
                      : 0 + parseInt(y[4])
                      ? parseInt(y[4])
                      : 0 + parseInt(y[5])
                      ? parseInt(y[5])
                      : 0
                    y[6] = sum === 0 ? sum : ""
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}>
                Итого VII
                <Input type="number" value={this.state[formnum][fieldnum][6]} />
              </div>
            </div>
          </div>
        </div>
      </>
    )
    return field
  }

  ftype3 = (num, text, formnum, fieldnum) => {
    let field = (
      <>
        <div>
          <div>
            <Input disabled value={num} />
            <span style={{ display: "inline-block", width: 10 }}></span>
            {text}
          </div>
          <div>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <div>
                1 мес. I
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][0]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[0] = d.value
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div>
                2 мес. II
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][1]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[1] = d.value
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
              <div>
                3 мес. III
                <Input
                  type="number"
                  value={this.state[formnum][fieldnum][2]}
                  onChange={(e, d) => {
                    const form = this.state[formnum]
                    const y = form[fieldnum]
                    y[2] = d.value
                    form[fieldnum] = y
                    const newState = {}
                    newState[formnum] = form
                    this.setState(newState)
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
    return field
  }

  ftype4 = (text, fieldnum, formnum, index, formulae, onChange) => {
    let field = (
      <>
        <div
          style={{
            marginLeft: 20,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <p>{text}</p>
          <span style={{ display: "inline-block", width: 10 }}></span>
          <Input
            value={fieldnum ? this.state[formnum][fieldnum][index] : ""}
            onChange={
              formulae
                ? (e, d) => {
                    if (formulae === "self") {
                      const form = this.state[formnum]
                      if (index) {
                        form[fieldnum][index] = d.value
                      } else {
                        form[fieldnum] = d.value
                      }
                      const newState = {}
                      newState[formnum] = form
                      this.setState(newState)
                    } else {
                      if (onChange) {
                        onChange(e, d)
                      } else {
                        const form = this.state[formnum]
                        if (index) {
                          form[fieldnum][index] = d.value
                        } else {
                          form[fieldnum] = d.value
                        }
                        const newState = {}
                        newState[formnum] = form
                        this.setState(newState)
                        formulae.map((formula) => {
                          this.formulaeDecomposer(formula)
                        })
                      }
                    }
                  }
                : onChange
                ? (e, d) => {
                    onChange(e, d)
                  }
                : () => {}
            }
          />
        </div>
      </>
    )
    return field
  }

  ftype5 = (fieldnum) => {
    let field = <></>
    if (fieldnum === "F000") {
      field = this.getf910F000()
    } else if (fieldnum === "910header") {
      field = this.getf910header()
    }
    return field
  }

  ftype6 = () => {
    let field = (
      <>
        <div>
          <Divider />
        </div>
      </>
    )
    return field
  }

  ftype7 = () => {
    let field = (
      <>
        <div style={{ textAlign: "center" }}>
          <h5>
            Добавьте данные по работникам, включая размер заработной платы за
            каждый месяц и статус работника.
          </h5>
        </div>
        <p style={{ marginTop: 10 }}></p>
        {this.state.workers.map((el) => el)}
        <Button
          positive
          content="+ Добавить работника"
          onClick={this.addWorker}
        />
        <p style={{ display: "inline-block", width: 20 }}></p>
        <Button
          negative
          content="- Удалить работника"
          onClick={this.deleteWorker}
        />
      </>
    )
    return field
  }

  addField = (q, formnum) => {
    const { ftype, num, text, fieldnum, formulae, index } = q
    let onChange = false
    if (fieldnum === "F001" && formnum === "form910") {
      onChange = (e, d) => {
        const form910 = this.state.form910
        if (index === "0") {
          form910.F001[0] = d.value
          form910.F001[2] = form910.F000[6] - d.value + ""
        } else if (index === "2") {
          form910.F001[2] = d.value
          form910.F001[0] = form910.F000[6] - d.value + ""
        }
        form910.F001b = false
        form910.F001d = false
        if (form910.F001[2] < 0) {
          form910.F001[2] = ""
          form910.F001b = true
        }
        this.setState({ form910: form910 })
      }
    } else if (fieldnum === "F006" && formnum === "foem910") {
      onChange = (e, d) => {
        const form910 = this.state.form910
        form910.F006 = d.value
        const y =
          (parseInt(form910.F005) ? parseInt(form910.F005) : 0) -
          (parseInt(form910.F006) ? parseInt(form910.F006) : 0)
        form910.F007 = y >= 0 && form910.F005 !== "" && form910.F006 ? y : ""
        form910.F008 =
          y >= 0 && form910.F005 !== "" && form910.F006 ? y * 5 : ""
        form910.F006b = false
        form910.F005b = false
        form910.F011 =
          (parseInt(form910.F008) ? parseInt(form910.F008) : 0) -
          (parseInt(form910.F010) ? parseInt(form910.F010) : 0)
        if (y < 0) {
          form910.F006b = true
        }
        this.setState({ form910: form910 })
      }
    }
    let field = <></>
    if (ftype === 0) {
      // simple type { input, text, input }
      field = this.ftype0(
        num,
        text,
        formnum,
        fieldnum,
        formulae,
        index,
        onChange,
      )
    } else if (ftype === 1) {
      // 4 fields type
      field = this.ftype1(text, formnum, fieldnum, num, onChange)
    } else if (ftype === 2) {
      // 7 fields type
      field = this.ftype2(num, text, formnum, fieldnum, onChange)
    } else if (ftype === 3) {
      // 3 fields type
      field = this.ftype3(num, text, formnum, fieldnum, onChange)
    } else if (ftype === 4) {
      // simple { text, input }
      field = this.ftype4(text, fieldnum, formnum, index, formulae, onChange)
    } else if (ftype === 5) {
      // non starndart
      field = this.ftype5(fieldnum, onChange)
    } else if (ftype === 6) {
      // divider
      field = this.ftype6(onChange)
    } else if (ftype === 7) {
      // add working
      field = this.ftype7(onChange)
    }
    return (
      <>
        <div style={{ marginTop: 20 }}>{field}</div>
      </>
    )
  }

  getf910header = () => {
    let field = <></>
    field = (
      <>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <div>
            <Input
              checked={this.state.pervoePolugodie} // pervoePolugodie
              type="checkbox"
              onClick={() => {
                const form910 = this.state.form910
                if (!this.state.pervoePolugodie) {
                  form910.F000 = ["", "", "", "", "", "", ""]
                  form910.F001[0] = ""
                  form910.F001[2] = ""
                }
                this.setState({
                  pervoePolugodie: true,
                  vtoroyePolugodie: false,
                  form910: form910,
                })
              }}
            />
            <span>1 полугодие</span>
            <p></p>
            <Input
              checked={this.state.vtoroyePolugodie} // vtoroyePolugodie
              type="checkbox"
              onClick={() => {
                const form910 = this.state.form910
                if (!this.state.vtoroyePolugodie) {
                  form910.F000 = ["", "", "", "", "", "", ""]
                  form910.F001[0] = ""
                  form910.F001[2] = ""
                }
                this.setState({
                  pervoePolugodie: false,
                  vtoroyePolugodie: true,
                  form910: form910,
                })
              }}
            />
            <span>2 полугодие</span>
            <p></p>
            <Input
              checked={this.state.prevYear} // prevYear
              type="checkbox"
              onClick={() => {
                const form910 = this.state.form910
                if (!this.state.prevYear) {
                  form910.F000 = ["", "", "", "", "", "", ""]
                  form910.F001[0] = ""
                  form910.F001[2] = ""
                }
                this.setState({
                  prevYear: true,
                  thisYear: false,
                  year: year - 1,
                  form910: form910,
                })
              }}
              style={{ display: "none" }}
            />
            <span style={{ display: "none" }}>{year - 1} год</span>
            <p style={{ display: "inline-block", width: 20 }}></p>
            <Input
              checked={this.state.thisYear} // thisYear
              type="checkbox"
              onClick={() => {
                const form910 = this.state.form910
                if (!this.state.thisYear) {
                  form910.F000 = ["", "", "", "", "", "", ""]
                  form910.F001[0] = ""
                  form910.F001[2] = ""
                }
                this.setState({
                  prevYear: false,
                  thisYear: true,
                  year: year,
                  form910: form910,
                })
              }}
            />
            <span>{year} год</span>
          </div>
          <div>
            <Input
              checked={this.state.ip} // ip
              type="checkbox"
              onClick={() => {
                this.setState({ ip: true, too: false })
              }}
            />
            <span>ИП</span>
            <p></p>
            <Input
              checked={this.state.too} // too
              type="checkbox"
              onClick={() => {
                this.setState({ ip: false, too: true })
              }}
            />
            <span>ТОО</span>
          </div>
          <div>
            <span>{"Пенсионер: "}</span>
            <Input
              type="checkbox"
              checked={this.state.pensioner} // pensioner
              onClick={() => {
                const old = this.state.pensioner
                this.setState({ pensioner: !old })
              }}
            />
          </div>
        </div>
      </>
    )
    return field
  }

  getf910F000 = () => {
    let field = <></>
    field = (
      <>
        <div>
          <Input disabled value="910.00.001" />
          <span
            onClick={() => {
              const q = document.getElementById("910.00.001").style.display
              document.getElementById("910.00.001").style.display = "block"
              if (q === "none") {
                document.getElementById("910.00.001").style.display = "block"
              } else if (q === "block") {
                document.getElementById("910.00.001").style.display = "none"
              }
            }}
          >
            {" Доход "}
            <Icon name="arrow down" />
          </span>
          <Input
            type="number"
            style={{ float: "right" }} // F000[6]
            value={this.state.form910.F000[6]}
          />
          <div id="910.00.001" style={{ display: "none" }}>
            Доход по месяцам влияет на расчет социальных отчислений и
            обязательных пенсионных взносов.
            {this.state.pervoePolugodie ? (
              pervoePolugodie.map((el, i) => (
                <>
                  <div>
                    <Input
                      type="number"
                      onChange={(e, d) => {
                        const form910 = this.state.form910
                        const y = form910.F000
                        y[i] = d.value
                        let sum = 0
                        y.map((q, i) => {
                          if (i !== 6) {
                            sum = sum + (parseInt(q) ? parseInt(q) : 0)
                          }
                        })
                        y[6] = sum !== 0 ? sum + "" : ""
                        form910.F005 =
                          0.03 * (parseInt(y[6]) ? parseInt(y[6]) : -1) !==
                          -0.03
                            ? 0.03 * parseInt(y[6])
                            : ""
                        form910.F000 = y
                        form910.F001[0] = ""
                        form910.F001[2] = ""
                        this.setState({ form910: form910 })
                      }}
                      value={this.state.form910.F000[i]} // F000[1]
                    />
                    <span>
                      {" Доход за " + el + " " + this.state.year + " года"}
                    </span>
                  </div>
                </>
              ))
            ) : (
              <></>
            )}
            {this.state.vtoroyePolugodie ? (
              vtoroyePolugodie.map((el, i) => (
                <>
                  <div>
                    <Input
                      type="number"
                      onChange={(e, d) => {
                        const form910 = this.state.form910
                        const y = form910.F000
                        y[i] = d.value
                        let sum = 0
                        y.map((q, i) => {
                          if (i !== 6) {
                            sum = sum + (parseInt(q) ? parseInt(q) : 0)
                          }
                        })
                        y[6] = sum !== 0 ? sum + "" : ""
                        form910.F005 =
                          0.03 * (parseInt(y[6]) ? parseInt(y[6]) : -1) !==
                          -0.03
                            ? 0.03 * parseInt(y[6])
                            : ""
                        form910.F001[0] = ""
                        form910.F001[2] = ""
                        this.setState({ form910: form910 })
                      }}
                      value={this.state.form910.F000[i]} // F000[2]
                    />
                    <span>
                      {" Доход за " + el + " " + this.state.year + " года"}
                    </span>
                  </div>
                </>
              ))
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    )
    return field
  }

  deleteWorker = () => {
    const workers = [...this.state.workers]
    workers.pop()
    this.setState({ workers: workers })
  }

  sendForm = () => {
    // const url = sendFnoFormApi + "/:" + this.props.num
    const url = "http://stax.kz:60883/fno/read" + "/" + this.props.num
    // http://stax.kz:60883/fno/read/200
    let form = {}
    if (parseInt(this.props.num) === 200) {
      form = {
        F001: this.state.form200.F001,
        F002: this.state.form200.F002,
        F003: this.state.form200.F003,
        F004: this.state.form200.F004,
        F005: this.state.form200.F005,
        F006: this.state.form200.F006,
        F007: this.state.form200.F007,
        F008: this.state.form200.F008,
        F010: this.state.form200.F010,
        F011: this.state.form200.F011,
        F01001: this.state.form200.F01001,
        F01002: this.state.form200.F01002,
        F01003: this.state.form200.F01003,
        F01004: this.state.form200.F01004,
        F01005: this.state.form200.F01005,
        F01006: this.state.form200.F01006,
        F01007: this.state.form200.F01007,
        F01008: this.state.form200.F01008,
        F01009: this.state.form200.F01009,
        F01010: this.state.form200.F01010,
        F01011: this.state.form200.F01011,
        F01012: this.state.form200.F01012,
        F01013: this.state.form200.F01013,
        F01014: this.state.form200.F01014,
        F01015: this.state.form200.F01015,
        F01016: this.state.form200.F01016,
        F01017: this.state.form200.F01017,
      }
    } else if (parseInt(this.props.num) === 910) {
      const y = []
      this.state.form910.F001.map((q) => y.push(q))
      y.push(this.state.form910.F000[6])
      form = {
        IsPens: this.state.pensioner,
        F001: y,
        F002: this.state.form910.F002 + "",
        F003: this.state.form910.F003,
        F004: this.state.form910.F004 + "",
        F005: this.state.form910.F005 + "",
        F006: this.state.form910.F006 + "",
        F007: this.state.form910.F007 + "",
        F008: this.state.form910.F008 + "",
        F009: this.state.form910.F009 + "",
        F010: this.state.form910.F010 + "",
        F011: this.state.form910.F011 + "",
        F012: this.state.form910.F012,
        F013: this.state.form910.F013,
        F014: this.state.form910.F014,
        F015: this.state.form910.F015,
        F016: this.state.form910.F016,
        F017: this.state.form910.F017,
        F018: this.state.form910.F018,
        F019: this.state.form910.F019,
        F020: this.state.form910.F020,
        F021: this.state.form910.F021,
        F022: this.state.form910.F022,
        F023: this.state.form910.F023,
        F024: this.state.form910.F024,
        F025: this.state.form910.F025,
        F026: this.state.form910.F026,
        F027: this.state.form910.F027,
      }
    }
    form.Period = this.state.vtoroyePolugodie ? 2 : 1
    form.Year = this.state.year
    form.NPType = this.state.ip
      ? "ИП"
      : this.state.too
      ? "ТОО"
      : this.state.sh
      ? "СХ"
      : ""
    apiPost(url, JSON.stringify(form))
      .onOk((res) => {
        alert(JSON.stringify(res.data))
        console.log(res.data)
      })
      .onFail((res) => {
        alert(JSON.stringify(res))
      })
      .onThrow((res) => {
        alert(JSON.stringify(res))
      })
      .start()
  }

  render() {
    const { type } = this.props
    if (type === "esf") return <FormESF />

    let form = []
    let formToRender = <></>
    let formValid = false
    let formnum = ""
    if (parseInt(this.props.num) === 910) {
      form = form910
      formnum = "form910"
      formValid = true
    } else if (parseInt(this.props.num) === 200) {
      form = form200
      formnum = "form200"
      formValid = true
    }
    formToRender = form.map((q) => {
      if (q.type === "header") {
        return this.addHeader(q.formnum, q.text)
      } else if (q.type === "title") {
        return this.addTitle(q.text)
      } else if (q.type === "field") {
        return this.addField(q, formnum)
      }
    })
    const toRender = (
      <div id="toRender">
        <Card fluid>
          <Card.Content>{formToRender.map((q) => q)}</Card.Content>
        </Card>
      </div>
    )
    return (
      <>
        {formValid ? (
          <>
            {toRender}
            <div>
              <Button
                // style={{ display: "none" }}
                content={"Экспорт в PDF"}
                style={{ float: "right", marginBottom: 30, marginTop: 10 }}
                onClick={() => {
                  const tor = document.getElementById("toRender")
                  const opt = {
                    margin: 1,
                    filename: "myfile.pdf",
                    image: { type: "jpeg", quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: {
                      unit: "in",
                      format: "letter",
                      orientation: "portrait",
                    },
                  }
                  html2pdf()
                    .set(opt)
                    .from(tor)
                    .save()
                }}
              />
              <Button content={"Отправить"} onClick={this.sendForm} />
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    )
  }
}
